import WebsiteModel        from '@models/website/WebsiteModel';
import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Addable }         from '@widesk-core/decorators/addable';
import { Editable }        from '@widesk-core/decorators/editable';
import { Deletable }       from '@widesk-core/decorators/deletable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';
import MenuTypeModel       from '../MenuTypeModel';

@doc.path('/menus/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractMenuModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'menuType': string;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'reference': Website_MenuReference;
		'label': id;
		'website': id;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		reference: string;
		label: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare label: string;
	declare menuType: MenuTypeModel;
	@doc.string declare reference: Website_MenuReference;
	@doc.model(WebsiteModel) declare website: WebsiteModel;
}

interface AbstractMenuModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractMenuModel;
